<script>
// Picto Talkizy (caméra + étincelle) en vecteur, colorable via `currentColor` :
// permet un rendu noir & blanc ou aux couleurs du store selon le contexte.
export default {
  name: 'TalkizyLogoMark',
};
</script>

<template>
  <svg
    class="talkizylogomark"
    viewBox="0 0 32 19"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Talkizy"
  >
    <path d="M32 9.29269C32 11.3582 31.6935 13.2394 31.1887 14.6515C31.1505 14.7586 31.0282 14.809 30.9247 14.7625L25.2786 12.238V18.3867C25.2786 18.4964 25.19 18.5854 25.0809 18.5854H6.04968C5.96631 18.5854 5.89513 18.5336 5.86613 18.4602V17.2489C5.86613 16.082 5.93182 14.9159 6.0703 13.7573C6.16246 12.9862 6.2725 12.344 6.44609 11.8069C6.72454 10.9453 7.3841 10.2537 8.236 9.94694C9.21103 9.59579 10.564 9.48211 12.4837 9.25216H12.486C10.6339 9.08327 9.29671 8.9734 8.31949 8.63336C7.39015 8.30998 6.68908 7.53774 6.43857 6.58617C6.29331 6.03439 6.19526 5.37379 6.0968 4.58128C5.94551 3.36364 5.87107 2.13759 5.87107 0.910585V0.114015C5.90271 0.0464625 5.97092 0 6.04968 0H25.0809C25.19 0 25.2786 0.0889709 25.2786 0.199034V6.34769L30.9248 3.82318C31.0282 3.77672 31.1505 3.82714 31.1887 3.93423C31.6935 5.34626 32 7.22753 32 9.29269Z" />
    <path d="M4.45743 4.84101C4.65923 6.46443 4.72401 7.49572 5.1177 8.16183C5.76051 8.98835 6.87178 9.0673 8.91488 9.2548C6.90417 9.49658 5.81781 9.54838 5.17501 10.3058C4.69413 10.9769 4.61191 12.0131 4.45743 13.6686C4.19578 11.5246 4.15344 10.4415 3.20413 9.82472C2.5289 9.50152 1.52232 9.43242 0 9.2548C1.88609 9.02535 2.97989 8.97355 3.63268 8.40363C4.18332 7.75229 4.24313 6.67414 4.45743 4.84348L4.45743 4.84101Z" />
  </svg>
</template>

<style lang="scss" scoped>
.talkizylogomark {
  display: inline-block;
  height: 1em;
  width: auto;
  vertical-align: middle;
}
</style>
